module.exports = __webpack_public_path__ + "img/vandijk.nl.ea155dc.png";